import { createRoutine } from 'redux-saga-routines';

export const getReportRoutine = createRoutine('GET_REPORT');
export const searchReportUsersRoutine = createRoutine('SEARCH_REPORT_USERS');
export const setReportCandidatesRoutine = createRoutine('SET_REPORT_CANDIDATES');
